import * as SMS from 'expo-sms';

import { logError, logEvent } from '@helpers/Loggers';

export async function sendSMSMessage(message: string, addresses: string | string[] = []) {
  try {
    const available = await SMS.isAvailableAsync();
    if (available) {
      const response = await SMS.sendSMSAsync(addresses, message);
      logEvent('send_sms', { result: response.result, message });
    }
  } catch (error) {
    logError(error);
  }
}
